// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".single[data-v-c26aa9e8]{height:100%}.single--title[data-v-c26aa9e8]{position:relative}.single--title[data-v-c26aa9e8]:before{content:\"\";position:absolute;left:0;height:.25rem;width:2.5rem;border-radius:.25rem;--bg-opacity:1;background-color:#0f1c3f;background-color:rgba(15,28,63,var(--bg-opacity));bottom:0;margin-bottom:-.75rem}[data-v-c26aa9e8] .swiper-wrapper .swiper-slide{height:auto!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
